import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { posts } from '../data/posts';
export function BlogsPage() {
  return <section className="px-6 py-24 bg-white min-h-screen" data-id="element-124">
      <div className="max-w-7xl mx-auto" data-id="element-125">
        <motion.div className="mb-16 md:mb-24 max-w-3xl" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-126">
          <h1 className="text-4xl md:text-5xl font-serif mb-6 text-[#4A3B47]" data-id="element-127">
            All Articles
          </h1>
          <p className="text-lg text-[#4A3B47]/70 leading-relaxed" data-id="element-128">
            Thoughts on brand strategy, community building, and user experience
            design.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-129">
          {posts.map((post, index) => <motion.article key={post.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group cursor-pointer flex flex-col h-full" data-id="element-130">
              <Link to={`/blog/${post.id}`} className="block" data-id="element-131">
                <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-132">
                  <div className="absolute inset-0 bg-[#4A3B47]/10 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-133" />
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-134" />
                  <div className="absolute top-4 left-4 z-20 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-medium text-[#4A3B47] uppercase tracking-wider" data-id="element-135">
                    {post.category}
                  </div>
                </div>
              </Link>

              <div className="flex flex-col flex-grow" data-id="element-136">
                <div className="text-sm text-[#A88B9D] mb-3 font-medium" data-id="element-137">
                  {post.date}
                </div>
                <h3 className="text-2xl font-serif text-[#4A3B47] mb-3 group-hover:text-[#A88B9D] transition-colors duration-300" data-id="element-138">
                  <Link to={`/blog/${post.id}`} data-id="element-139">{post.title}</Link>
                </h3>
                <p className="text-[#4A3B47]/70 leading-relaxed mb-6 flex-grow" data-id="element-140">
                  {post.excerpt}
                </p>

                <Link to={`/blog/${post.id}`} className="flex items-center text-[#4A3B47] font-medium group-hover:text-[#A88B9D] transition-colors duration-300 mt-auto" data-id="element-141">
                  Read Article{' '}
                  <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" data-id="element-142" />
                </Link>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}